module.exports = __webpack_public_path__ + "media/logos/logo_footer@2x-ff0d6a00.png";